"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Licence = void 0;
var Licence;
(function (Licence) {
  Licence["ESTONIA"] = "EE";
  Licence["MALTA"] = "MT";
  Licence["MEXICO"] = "MX";
  Licence["PERU"] = "PE";
  Licence["SIMULATED_GAMING"] = "SIM";
  Licence["SWEDEN"] = "SE";
  Licence["USA_ARIZONA"] = "US-AZ";
  Licence["USA_ARKANSAS"] = "US-AR";
  Licence["USA_MASSACHUSETTS"] = "US-MA";
  Licence["USA_MICHIGAN"] = "US-MI";
  Licence["USA_MISSISSIPPI"] = "US-MS";
  Licence["USA_NEVADA"] = "US-NV";
  Licence["USA_NEW_YORK"] = "US-NY";
})(Licence || (exports.Licence = Licence = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGljZW5jZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9saWNlbmNlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksT0FjWDtBQWRELFdBQVksT0FBTztJQUNmLHlCQUFjLENBQUE7SUFDZCx1QkFBWSxDQUFBO0lBQ1osd0JBQWEsQ0FBQTtJQUNiLHNCQUFXLENBQUE7SUFDWCxtQ0FBd0IsQ0FBQTtJQUN4Qix3QkFBYSxDQUFBO0lBQ2IsZ0NBQXFCLENBQUE7SUFDckIsaUNBQXNCLENBQUE7SUFDdEIsc0NBQTJCLENBQUE7SUFDM0IsaUNBQXNCLENBQUE7SUFDdEIsb0NBQXlCLENBQUE7SUFDekIsK0JBQW9CLENBQUE7SUFDcEIsaUNBQXNCLENBQUE7QUFDMUIsQ0FBQyxFQWRXLE9BQU8sdUJBQVAsT0FBTyxRQWNsQiJ9